export class KolektivClients {

  public age: number;
  public id: number;
  public premiumEUR: number;
  public premiumMKD: number;
  public osEUR: number;
  public osMKD: number;
}


export class Kolektivmodel {
  

  public sema: number;
  public vrstaIzracuna: number;
  public iznos: number;
  public starost: number;
  public brojOsiguranika: number;
  public valuta: string;

  public napomena: string;
  public lClients: KolektivClients[];
}



// WEBPACK FOOTER //
// ./src/app/models/kolektiv-clients.model.ts